export default __webpack_public_path__ + "static/media/phone.1f92f8f9.svg";